/* eslint-env browser */

if (typeof window !== 'undefined' && window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window
    for (let i = 0; i < this.length; i += 1) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

// t = current time
// b = start value
// c = change in value
// d = duration
const easeInOutQuad = function(t, b, c, d) {
  t /= d / 2
  if (t < 1) return (c / 2) * t * t + b
  t -= 1
  return (-c / 2) * (t * (t - 2) - 1) + b
}

module.exports = {
  onDocumentReady(fn) {
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
      fn()
    } else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  },
  on(object, type, callback) {
    if (object == null || typeof object === 'undefined') return
    if (object.addEventListener) {
      object.addEventListener(type, callback, false)
    } else if (object.attachEvent) {
      object.attachEvent(`on${type}`, callback)
    } else {
      object[`on${type}`] = callback
    }
  },
  query(elt, selector) {
    if (!selector) {
      selector = elt
      elt = document
    }
    return elt.querySelector(selector)
  },
  queryAll(elt, selector) {
    if (!selector) {
      selector = elt
      elt = document
    }
    return elt.querySelectorAll(selector)
  },
  data(elt, data) {
    return elt.getAttribute(`data-${data}`)
  },
  hasClass(elt, className) {
    if (elt.classList) {
      return elt.classList.contains(className)
    }
    return elt.className.indexOf(className) !== -1
  },
  toggleClass(elt, className) {
    if (!elt) {
      return
    }
    if (elt.classList) {
      elt.classList.toggle(className)
    } else {
      const classes = elt.className.split(' ')
      const existingIndex = classes.indexOf(className)
      if (existingIndex >= 0) {
        classes.splice(existingIndex, 1)
      } else {
        classes.push(className)
      }
      elt.className = classes.join(' ')
    }
  },
  addClass(elt, className) {
    if (!elt) {
      return
    }
    if (elt.classList) {
      className.split(' ').forEach(clazzName => elt.classList.add(clazzName))
    } else {
      elt.className += ` ${className}`
    }
  },
  removeClass(elt, className) {
    if (!elt) {
      return
    }
    if (elt.classList) {
      className.split(' ').forEach(clazzName => elt.classList.remove(clazzName))
    } else {
      className.split(' ').forEach(clazzName => {
        elt.className = elt.className.replace(new RegExp(`(^|\\b)${clazzName.split(' ').join('|')}(\\b|$)`, 'gi'), ' ')
      })
    }
  },
  scrollTo(element, to) {
    if (typeof element === 'string') {
      element = this.query(element)
    }
    if (!element) {
      return
    }
    const start = element.scrollTop
    const change = to - start
    let currentTime = 0
    const increment = 20

    const duration = 200
    const animateScroll = () => {
      currentTime += increment
      const val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll()
  },
  scrollToTarget(element, targetElement) {
    if (typeof element === 'string') {
      element = this.query(element)
    }
    if (typeof targetElement === 'string') {
      targetElement = this.query(targetElement)
    }
    if (!element || !targetElement) {
      return
    }
    const start = element.scrollTop
    const change = targetElement.offsetTop + targetElement.clientHeight - start
    let currentTime = 0
    const increment = 20

    const duration = 200
    const animateScroll = () => {
      currentTime += increment
      const val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll()
  },
  toggleCollapsible(element) {
    if (typeof element === 'string') {
      element = this.query(element)
    }
    if (!element) {
      return
    }
    this.toggleClass(element, 'is-collapsed')
  },
  copyToClipBoard(text) {
    const el = document.createElement('textarea') // Create a <textarea> element
    el.value = text // Set its value to the string that you want copied
    el.setAttribute('readonly', '') // Make it readonly to be tamper-proof
    el.style.position = 'absolute'
    el.style.left = '-9999px' // Move outside the screen to make it invisible
    document.body.appendChild(el) // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection().rangeCount > 0 // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0) // Store selection if found
        : false // Mark as false to know no selection existed before
    el.select() // Select the <textarea> content
    document.execCommand('copy') // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el) // Remove the <textarea> element
    if (selected) {
      // If a selection existed before copying
      document.getSelection().removeAllRanges() // Unselect everything on the HTML document
      document.getSelection().addRange(selected) // Restore the original selection
    }
  },
}
